<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16o3FYs/tc-custom/9780253061850.jpg?1733088587895" alt="This image is the cover for the book Three Midwestern Playwrights"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Three Midwestern Playwrights
      </h1>
      <p class="bookDescription body article font2">
        <p><b>In the early 1900s, three small-town midwestern playwrights </b><b>helped shepherd American theatre into the modern era. Together, they created the renowned Provincetown Players collective, which not only launched many careers but also had the power to </b><b>affect US social, cultural, and political beliefs.</b></p><p>The philosophical and political orientations of Floyd Dell, George Cram Cook, and Susan Glaspell generated a theatre practice marked by experimentalism, collaboration, leftist cultural critique, rebellion, liberation, and community engagement. In <i>Three Midwestern Playwrights</i>, Marcia Noe situates the origin of the Provincetown aesthetic in Davenport, Iowa, a Mississippi River town. All three playwrights recognized that radical politics sometimes begat radical chic, and several of their plays satirize the faddish elements of the progressive political, social, and cultural movements they were active in.</p><p><i>Three Midwestern Playwrights</i> brings the players to life and deftly illustrates how Dell, Cook, and Glaspell joined early 20th-century midwestern radicalism with East Coast avant-garde drama, resulting in a fresh and energetic contribution to American theatre. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marcia Noe
      </h2>
      
      <p class="authorDescription body article"><P>Marcia Noe is author of<I> Susan Glaspell: Voice from the Heartland</I> and over 20 other publications on this Pulitzer Prize–winning playwright. Noe edits the academic journal <I>MidAmerica</I> for the Society for the Study of Midwestern Literature and is Professor of English and Director of Women, Gender, and Sexuality Studies at the University of Tennessee at Chattanooga.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4aac1133